module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-item-6-da14405c3aba3e2cc912ca686e3586b7.jpg";